import React from 'react';
import PropTypes from 'prop-types';

import ButtonDeprecated from "core/gd-components/buttons/gd-button/gd-button";
import {Feature} from "core/gd/access-control/feature-access/const";

export default function AddCustomField(props) {

    const company       = gd.session.companies.get(gd.companyId);
    const showNewButton = props.project ? gd.ac.check.canCreateCustomFields(props.project.id) : true;

    if (!showNewButton) return false;

    if (company.license.customFields) {
        return (
            <div className="row cf new-field">
                <div className="element">
                    <ButtonDeprecated label="+ New Custom Field" onClick={props.onClickNew} type="blue" size="small"/>
                </div>
                <div className="cf" />
            </div>
        );
    } else {
        return (
            <div className="row cf new-field">
                <div className="element">
                    <ButtonDeprecated label="+ New Custom Field" onClick={()=>{gd.modals.other.upgradeToPro(Feature.CUSTOM_FIELDS)}} type="gray" size="small"/>
                    <span className="i5-pro"/>
                </div>
                <div className="cf" />
            </div>
        );
    }
}

AddCustomField.propTypes = {
    project: PropTypes.object,
    onClickNew: PropTypes.func
}